/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import * as Yup from 'yup';

export const blockSchema = Yup.object().shape({
  block_actions_time_duration: Yup.string().required(
    i18n.t('REQUIRED_FIELD_KEY')
  ),
  block_reason: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .trim()
    .min(20, i18n.t('MIN_LENGTH_KEY', { value: 20 }))
    .max(
      100,
      i18n.t('REQUIRE_MAX_LENGTH_TEXT_KEY', {
        max_length: 100,
      })
    ),
});

export const unblockSchema = Yup.object().shape({
  unblock_reason: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .trim()
    .min(20, i18n.t('MIN_LENGTH_KEY', { value: 20 }))
    .max(
      100,
      i18n.t('REQUIRE_MAX_LENGTH_TEXT_KEY', {
        max_length: 100,
      })
    ),
});
